export default {
    'language': '挪威语',
}
;
